import { useQuery } from "@tanstack/react-query"
import { getDashboardData } from "../../API/functions"
 
export const useDashboardData = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["dashboardData"],
        queryFn: () => getDashboardData(),
        retry: false, 
      });
    return {data , error, isLoading}
}